import * as React from 'react'
import { styled } from '@mui/material/styles'

const Wrapper = styled('span')`
    display: inline;
    font-weight: normal;
    padding: 1px 4px;
    background-color: ${({ theme }) => theme.palette.divider};
    color: ${({ theme }) => theme.palette.text.primary};
    border-radius: ${({ theme }) => `${theme.shape.borderRadius}px`};
`

const CodeBlockInline = ({ children }: { children: React.ReactNode }) => {
    return (
        <Wrapper>
            <code>{children}</code>
        </Wrapper>
    )
}

export default CodeBlockInline
